import { isString } from 'react-shared/utils/is'

export const slugify = (string, delimiter = '-') =>
  String(string || '')
    .toLowerCase()
    .replace(/[\u00C0-\u00C5]/gi, 'a')
    .replace(/[\u00E7]/gi, 'c')
    .replace(/[\u00C8-\u00CB]/gi, 'e')
    .replace(/[\u00CC-\u00CF]/gi, 'i')
    .replace(/[\u00D2-\u00D6]/gi, 'o')
    .replace(/[\u00D9-\u00DC]/gi, 'u')
    .replace(/[\u00D1]/gi, 'n')
    .replace(/[^a-z0-9\s]*/gi, '')
    .trim()
    .replace(/\s+/g, delimiter)
    .replace(/[-]{2,}/g, '')

export const unsafe = input => {
  const dom = new DOMParser().parseFromString(input, 'text/html')
  return ((dom || {}).documentElement || {}).textContent || ''
}

export const firstLetterUpperCase = (value = '') => {
  if (!value || !isString(value)) {
    return
  }
  return `${value[0].toUpperCase()}${value.slice(1).toLowerCase()}`
}

export const makeFirstLetterUpperCase = (value = '') =>
  isString(value) ? `${value.slice(0, 1).toUpperCase()}${value.slice(1)}` : null

export const toProperCase = value =>
  isString(value) && value.split(' ').map(firstLetterUpperCase).join(' ')

const words = string => String(string).split(/\s+/)

export const firstWords = (string, wordQtt) => words(string).slice(0, wordQtt).join(' ')

export const lastWords = (string, wordQtt) =>
  words(string)
    .slice(-1 * wordQtt)
    .join(' ')

export const fixedDigits = (number, digits) => `${number}`.padStart(digits, '0')

export const onlyDigits = value => (value || '').replace(/\D/g, '')

export const onlyText = value => (value || '').replace(/[^a-z\u00C0-\u017F ]+/gi, '')

export const stripTags = str =>
  String(str)
    .replace(/<br ?\/?>/g, '\n')
    .replace(/<[^>]+>/g, '')
    .replace(/&(\w+|#([xX][a-fA-F\d]+|\d+));/g, '')

export const firstLetterLowerCase = (value = '') =>
  value && isString(value) ? `${value[0].toLowerCase()}${value.slice(1)}` : ''

export const removeAccents = str =>
  isString(str)
    ? str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
    : str

export const normalizeHtml = html => (html || '').replace(/<\/?font[^>]*>/g, '')

const stripForComparison = str => removeAccents(str || '').replace(/\W/g, '')

export const includesStripped = (str1, str2) =>
  stripForComparison(str1).includes(stripForComparison(str2))

export const isLetterUppercased = letter =>
  !!letter && letter == letter.toUpperCase() && letter !== letter.toLowerCase()

export const endsWithUppercasedLetter = str => !!str && isLetterUppercased(`${str}`.slice(-1))

export const moneyToNumber = value =>
  Number(
    String(value || 0)
      .replace(',', '.')
      .replace(/[^.\d-]/g, '')
  )
